// extracted by mini-css-extract-plugin
export var actionText = "_px-4";
export var container = "_px-0";
export var leftSection = "_px-1";
export var rightSection = "_px-2";
export var settingsButton = "_px-6";
export var settingsIcon = "_px-7";
export var shortcut = "_px-5";
export var shortcutGroup = "_px-3";